var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60382 1.2V6.95903H14.9187V1.2H9.60382ZM9.55989 0C8.9214 0 8.40382 0.51759 8.40382 1.15607V7.00296C8.40382 7.64144 8.92141 8.15903 9.55989 8.15903H14.9627C15.6011 8.15903 16.1187 7.64144 16.1187 7.00296V1.15607C16.1187 0.51759 15.6011 0 14.9627 0H9.55989ZM1.2 15.041V20.8H6.51491V15.041H1.2ZM1.15607 13.841C0.51759 13.841 0 14.3586 0 14.997V20.8439C0 21.4824 0.517591 22 1.15607 22H6.55884C7.19732 22 7.71491 21.4824 7.71491 20.8439V14.997C7.71491 14.3586 7.19732 13.841 6.55884 13.841H4.4576V12.2558H19.3763V13.841H17.2746C16.6361 13.841 16.1186 14.3586 16.1186 14.997V20.8439C16.1186 21.4824 16.6362 22 17.2746 22H22.6774C23.3159 22 23.8335 21.4824 23.8335 20.8439V14.997C23.8335 14.3586 23.3159 13.841 22.6774 13.841H20.5763V11.6558V11.0558H19.9763H12.861V8.15921H11.661V11.0558H3.8576H3.2576V11.6558V13.841H1.15607ZM17.3186 20.8V15.041H22.6335V20.8H17.3186Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVdt);
export default __webpack_public_path__ + "static/media/VDT.935e8d10.svg";
export { ForwardRef as ReactComponent };